var DefaultHeader = require("./DefaultHeader");
var PopupMenu = require("./PopupMenu");
var Utils = require("common/Utils");

/**
 * Header implementation used for resource 'pages'
 *
 * @class
 * @extends DefaultHeader
 */
function MainHeader(isTouch) {
    DefaultHeader.call(this);

    var $searchField = undefined; // This gets set when the first view is configured
    var showOptionsMenu = true;

    var self = this;

    var optionsMenu = new PopupMenu("optionsMenuContainer");
    $("#mobileResources").append(optionsMenu.getContent());

    var super_configure = this.configure;
    /**
     * Configure the header with a menu button on the left (if we are showing the hamburger button) and the necessary CSS class for the resources header
     *
     * @override
     */
    this.configure = function(config) {
        if (showOptionsMenu) {
            var optionsButton = optionsMenu.getButton();

            if (config.leftButtons) {
                config.leftButtons.push(optionsButton);
            } else {
                config.leftButtons = [optionsButton];
            }
        }

        if (config.additionalClasses) {
            config.additionalClasses += " resourcesHeader";
        } else {
            config.additionalClasses = "resourcesHeader";
        }

        if (config.searchHeader) {
            if ($searchField) {
                // Clear the search field of the current view (if we have one)
                var $input = $searchField.find("input[data-type='search']");
                $input.val("").trigger("change");
            }

            // Detach the search field from the view we are moving to so we can add it to the header
            $searchField = config.searchHeader.detach();
            config.searchHeader = $searchField;

            // Remove the default click handler of the clear search button
            var $searchDoneButton = $searchField.find(".ui-btn.ui-input-clear");
            $searchDoneButton.off("click");
            $searchDoneButton.on("click", function() {
                var $input = $searchField.find("input[data-type='search']");
                $input.val("").trigger("change");
            });
        }

        // Show/hide the title as necessary
        self.getContent().find(".ui-title").toggle(isTouch);

        super_configure.call(this, config);
    };

    this.addOptionsMenuEntry = function(title, clickHandler, weight) {
        return optionsMenu.addEntry(title, clickHandler, weight);
    };

    this.setShowOptionsMenu = function(showMenu) {
        showOptionsMenu = showMenu;
    };
}

Utils.inherits(MainHeader, DefaultHeader);

module.exports = MainHeader;